module.exports = __webpack_public_path__ + "static/media/elementary-school-coding.7e04a72f.webp";